import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center p-6 border-b-4 border-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-xl text-black" }, " Meu carrinho: ", -1)
const _hoisted_3 = { class: "flex flex-col gap-2 justify-center p-6" }
const _hoisted_4 = { class: "text-black relative flex flex-col flex-nowrap h-4/5 overflow-x-scroll px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CartItems = _resolveComponent("CartItems")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["z-50 fixed flex flex-col justify-start w-full px-2 h-full top-0 bg-white sm:w-96 transition-all duration-500 overflow-y-scroll", _ctx.show ? 'right-0' : '-right-full'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Icon, {
        icon: "teenyicons:x-solid",
        class: "text-cinza-padrao hover:cursor-pointer",
        onClick: _ctx.fechar
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_RouterLink, { to: "/cart" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "rounded bg-black text-white px-10 w-full py-3 font-bold hover:text-xl duration-150 ease-in-out",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fechar && _ctx.fechar(...args)))
          }, " Finalizar compra ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems.slice(1), (cartItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: cartItem?.product_id
        }, [
          _createVNode(_component_CartItems, {
            cartItem: cartItem,
            onClose: _ctx.fechar
          }, null, 8, ["cartItem", "onClose"])
        ]))
      }), 128))
    ])
  ], 2))
}